import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ScrollingModule } from '@angular/cdk/scrolling';

import { NgChartsModule } from 'ng2-charts';
import { FilterPipeModule } from 'ngx-filter-pipe';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgxBrazil } from 'ngx-brazil';
import { NgbAccordionModule, NgbCollapseModule, NgbModule, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';
import { NgxCurrencyDirective, provideEnvironmentNgxCurrency  } from "ngx-currency";
import { NgxLoadingModule } from 'ngx-loading';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { NgxUiLoaderConfig, NgxUiLoaderModule } from 'ngx-ui-loader';
import { NotaFiscalModule } from '../_componentes/notafiscal/notafiscal.module';
import { OrderModule } from 'ngx-order-pipe';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { PipesModule } from './pipes.module';
import { TooltipModule, TooltipOptions } from 'ng2-tooltip-directive';
import { NgScrollbarModule, provideScrollbarOptions } from 'ngx-scrollbar';
import { TranslateModule } from '@ngx-translate/core';

import { CancelHttpRequestsService } from 'app/_services/cancel-http-requests.service';
import { GeneralService } from '../_services/general.service';
import { ImageDisplayService } from 'app/_componentes/image-display/image-display.service';
import { NotificationService } from '../_services/notification.service';
import { PathResolveService } from '../_services/pathResolver.service';
import { SettingsService } from '../_services/settings.service';
import { SignalRService } from '../_services/signalr.service';
import { AnalyticsDirective } from '../_utils/analytics-directive.directive';

import { ButtonComponent } from 'app/_componentes/button/button.component';
import { HeaderComponent } from 'app/_componentes/header/header.component';
import { ImageDisplayComponent } from 'app/_componentes/image-display/image-display.component';

import { ArrowLeft, ArrowRight, ArrowUpRight, Award, Bell, CheckSquare, ChevronLeft, ChevronRight, ChevronDown, ChevronUp, ExternalLink, Eye, EyeOff, Frown, Info, RotateCcw, ShoppingCart, Star, Thermometer, ThumbsDown, ThumbsUp, Trash2, Truck, User, Users, X, Plus, Edit, ChevronsLeft, ChevronsRight, Check, Upload, Mail, WifiOff, RefreshCcw, RefreshCw, Search, Filter, Calendar, TrendingDown, TrendingUp, Zap } from 'angular-feather/icons';
import { FeatherModule } from 'angular-feather';
import { InputComponent } from 'app/_componentes/input/input.component';
import { InputAutoCompleteComponent } from 'app/_componentes/input-auto-complete/input-auto-complete.component';
import { InputDateComponent } from 'app/_componentes/input-date/input-date.component';
import { InputDigitComponent } from 'app/_componentes/input-digit/input-digit.component';
import { SelectComponent } from 'app/_componentes/select/select.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { ImagePickerComponent } from 'app/_componentes/image-picker/image-picker.component';
import { ImageCropperComponent } from 'ngx-image-cropper';

const MyDefaultTooltipOptions: TooltipOptions = { 'show-delay': 500 }

const icons = {
    ArrowLeft,
    ArrowRight,
    ArrowUpRight,
    Award,
    Bell,
    Calendar,
    Check,
    CheckSquare,
    ChevronLeft,
    ChevronsLeft,
    ChevronRight,
    ChevronsRight,
    ChevronDown,
    ChevronUp,
    Edit,
    ExternalLink,
    Eye,
    EyeOff,
    Filter,
    Frown,
    Info,
    Mail,
    Plus,
    RefreshCcw,
    RefreshCw,
    RotateCcw,
    Search,
    ShoppingCart,
    Star,
    Thermometer,
    ThumbsDown,
    ThumbsUp,
    Trash2,
    TrendingDown,
    TrendingUp,
    Truck,
    User,
    Users,
    Upload,
    WifiOff,
    X,
    Zap
};

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
    fgsColor: "#FE5D15",
    pbColor: "#FE5D15"
  };

@NgModule({
    declarations: [
        AnalyticsDirective,
        ButtonComponent,
        HeaderComponent,
        ImageDisplayComponent,
        ImagePickerComponent,
        InputComponent,
        InputAutoCompleteComponent,
        InputDateComponent,
        InputDigitComponent,
        SelectComponent
    ],
    exports: [
        HeaderComponent,
        CommonModule,
        NgChartsModule,
        FilterPipeModule,
        FormsModule,
        ModalModule,
        NgxBrazil,
        NgbModule,
        NgbAccordionModule,
        NgbCollapseModule,
        RecaptchaModule,
        RecaptchaFormsModule,
        NgxCurrencyDirective,
        NgxLoadingModule,
        NgxUiLoaderModule,
        NgScrollbarModule,
        NotaFiscalModule,
        PipesModule,
        PdfViewerModule,
        OrderModule,
        ReactiveFormsModule,
        ScrollingModule,
        TooltipModule,
        TranslateModule,

        AnalyticsDirective,
        ButtonComponent,
        ImageCropperComponent,
        ImageDisplayComponent,
        ImagePickerComponent,
        InputComponent,
        InputAutoCompleteComponent,
        InputDateComponent,
        InputDigitComponent,
        SelectComponent,
        FeatherModule,
        NgxMaskDirective,
        NgxMaskPipe,
    ],
    imports: [
        CommonModule,
        NgChartsModule,
        FilterPipeModule,
        FormsModule,

        ImageCropperComponent,
        ModalModule.forRoot(),
        NgbModule,
        NgbAccordionModule,
        NgbCollapseModule,
        NgxBrazil,
        RecaptchaModule,
        RecaptchaFormsModule,
        NgxLoadingModule,
        NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
        NgScrollbarModule,
        NotaFiscalModule,
        OrderModule,
        PipesModule,
        PdfViewerModule,
        ReactiveFormsModule,
        ScrollingModule,
        TooltipModule.forRoot(MyDefaultTooltipOptions),
        TranslateModule.forChild(),
        FeatherModule.pick(icons),
        MatAutocompleteModule,
        MatFormFieldModule,
        MatSelectModule,
        NgxMaskDirective,
        NgxMaskPipe,
        NgxCurrencyDirective
    ],
    providers: [
        CancelHttpRequestsService,
        GeneralService,
        NotificationService,
        PathResolveService,
        SettingsService,
        SignalRService,
        ImageDisplayService,
        provideEnvironmentNgxCurrency({
            align: "right",
            allowNegative: false,
            allowZero: true,
            decimal: ",",
            nullable: true,
            precision: 2,
            prefix: "",
            suffix: "",
            thousands: "."
        }),
        provideNgxMask(),
        provideHttpClient(withInterceptorsFromDi()),
        provideScrollbarOptions({
          visibility: 'hover'
        })
    ],
    bootstrap: []
})
export class SharedModule { }
